import { render, staticRenderFns } from "./Siklls-Cert-Lice.vue?vue&type=template&id=328653e2"
import script from "./Siklls-Cert-Lice.vue?vue&type=script&lang=js"
export * from "./Siklls-Cert-Lice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports